import Image from 'next/image';

import { NOPING_GREEN, V2A_GAMES } from '../constants';

export function GameCarousel() {
  const items = [...V2A_GAMES, ...V2A_GAMES];

  return (
    <div className='relative w-full overflow-hidden' style={{ maskImage: 'linear-gradient(to right, transparent, black 8%, black 92%, transparent)', WebkitMaskImage: 'linear-gradient(to right, transparent, black 8%, black 92%, transparent)' }}>
      <div className='v2a-game-track flex items-center'>
        {items.map((game, i) => (
          <div key={`${game.name}-${i}`} className='mx-3 w-[190px] shrink-0'>
            <div className='flex flex-col items-center gap-3 overflow-hidden rounded-2xl border p-3 transition-all duration-200 hover:scale-105' style={{ borderColor: `${NOPING_GREEN}20`, background: 'rgba(255,255,255,0.02)' }}>
              <div className='relative h-[220px] w-[160px] overflow-hidden rounded-xl'>
                <Image src={game.src} alt={game.name} fill className='object-cover' sizes='160px' />
              </div>
              <span className='w-full truncate text-center text-sm font-semibold' style={{ fontFamily: 'var(--font-outfit)', color: '#929298' }}>
                {game.name}
              </span>
            </div>
          </div>
        ))}
      </div>
      {/* `transform` is physical, so CSS never mirrors it for writing direction. This track is
          `width: max-content` inside a narrower clip box, so under the `dir="rtl"` that /sa inherits
          from <html> the over-constrained box anchors to the RIGHT edge and overflows left — and the
          negative shift then drags the strip out of the clip box instead of through it, draining it to
          empty partway through the loop. The mirrored keyframes shift positive; only `animation-name`
          is overridden, so duration and timing stay in one place. Same call as the home genre marquee. */}
      <style dangerouslySetInnerHTML={{ __html: '.v2a-game-track { animation: v2a-scroll-games 38s linear infinite; width: max-content; } .v2a-game-track:hover { animation-play-state: paused; } @keyframes v2a-scroll-games { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } } @keyframes v2a-scroll-games-rtl { 0% { transform: translateX(0); } 100% { transform: translateX(50%); } } [dir="rtl"] .v2a-game-track { animation-name: v2a-scroll-games-rtl; }' }} />
    </div>
  );
}
